<template>
  <div>
		<div :class="typeMessage" role="alert" id="message-update" v-if="message != '' && !create">
			{{message}}
		</div>    
    <div>
      <h4 v-if="create">CREAR CONTRATO</h4>
      <h4 v-else>EDITAR CONTRATO</h4>
    </div>

    <div class="row">
      <form ref="formContract">
        <div class="col-sm-4" v-if="!create">
          <label class="control-label">Número de contrato*</label>
          <input type="text" v-model="contract.contract_number" id="contract_number" class="form-control" disabled="true">
        </div>
        <div class="col-sm-4">
          <label class="control-label">Fecha de inicio*</label>
          <input type="date" v-model="contract.start_date" id="start_date" class="form-control">
        </div>
        <div class="col-sm-4">
          <label class="control-label">Fecha de finalización*</label>
          <input type="date" v-model="contract.end_date" id="end_date" class="form-control">        
        </div>            
        <div class="col-sm-12">
          <label class="control-label">Observaciones</label>
          <textarea name="" v-model="contract.observations" id="observations" cols="30" class="form-control" rows="10"></textarea>
        </div>   
      </form>
   
      </div>
    
      <div class="row row-btn">
        <div class="col-sm-12 text-right">
          <input type="button" id="btnGuardar" class="btn btn-primary" value="Guardar" @click="createUpdateContract('globaltec_session')">
        </div>
      </div>

      <modal-message/>

  </div>
</template>

<script>
import axios from 'axios';
import ModalMessage from './../modal-message/modal-message.vue'

export default {
  name:'FormContracts',
  data(){
    return{
      contract: {},
      token:'',
      message:'Prueba',
      showModal:false,
      create: true,
			message: '',
			typeMessage: ''      
    }
  },
  components: {
    'modal-message': ModalMessage
  },
  props:['client','_contract'],
  computed:{
    clientFromView:{
      get(){
        return this.client
      }
    },
    contracts: {
			get () {
				return this.$store.state.contracts
			},
			set (value){
				this.$store.commit('addContracts', value)				
			}
		}
  },
  methods: {
    createUpdateContract() {
      if(this.contract.start_date != undefined && this.contract.end_date != undefined){
        axios.defaults.headers['x-csrf-token'] = this.token
        axios.defaults.headers.common['Accept'] = 'application/json';
        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
        if(this.create){
          this.createContract()
        }else{
          this.updateContract()
        }
      }else{
        document.getElementById('textMessages').innerHTML = "Datos incompletos"
        document.getElementById('openModal').click()
      }
    },    
    createContract() {
      console.log("**createContract()**")
      axios.post(`/clients/${this.clientFromView.id}/contracts`,this.contract,{}).then(res=>{
        this.message = res.data.messages
        document.getElementById('textMessages').innerHTML = this.message
        if(res.data.contract.id != null){
          this.contracts = res.data.contract
          this.contract.contract_number = undefined
          this.contract.start_date = undefined
          this.contract.end_date = undefined
          this.contract.observations = undefined
        }
        document.getElementById('openModal').click()
      })
    },
    updateContract() {
      if(this.contract.start_date < this.contract.end_date){
        axios.put(`/contracts/${this.contract.id}`,this.contract,{}).then(res=>{
        if(res.status == 200){
          this.showMessage('Contrato actualizado', 'alert-success')
        }else{
          this.showMessage('No se pudo actualizar el contrato', 'alert-warning')
        }        
      }, (err) => {
        this.showMessage('No se pudo actualizar el contrato', 'alert-warning')
      })
      }else{
        this.showMessage('No se pudo actualizar el contrato', 'alert-warning')
      }
      
    },
		showMessage(message, typeMessage){
			this.message = message
			this.typeMessage = typeMessage
			setTimeout(() => this.message = '', 3000)
		},
    setContract() {
      if(this._contract != null){
        this.contract = this._contract
        this.create = false
      }      
    }
  },
  watch: {
    _contract() {
      this.setContract()      
    }
  },
  created(){
    this.token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    this.setContract()
  }
}
</script>

<style>

</style>